var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPluralsight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31.0461 31.0453 40 19.9995 40C8.95359 40 0 31.0461 0 20C0 8.95391 8.95359 0 19.9995 0C31.0453 0 40 8.95391 40 20Z",
    fill: "url(#paint0_linear_213_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8582 9.6062V30.392L32.8592 19.9996L14.8582 9.6062ZM16.5814 12.591L29.4127 19.9996L16.5814 27.4081V12.591Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7202 11.8752V28.1226L24.7898 19.9984L10.7202 11.8752ZM12.4434 14.8601L21.3444 19.9984L12.4434 25.1387V14.8601Z",
    fill: "#FFFFFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_213_56",
    x1: 1999.96,
    y1: 63.04,
    x2: 1999.96,
    y2: 4017.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7197E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluralsight);
export default __webpack_public_path__ + "static/media/pluralsight.bbde3de03671c7fddc588f555d33d108.svg";
export { ForwardRef as ReactComponent };